module.exports = __webpack_public_path__ + "70f7ef24b142ffcc63011c5a9eed1fc8.woff";